import Vue from 'vue';
import WidgetFrame from 'src/components/widgets/WidgetFrame/WidgetFrame.vue';
import QueryRow from './QueryRow';
import QueryUtils from 'src/utils/query';
import Utils from 'src/utils/general';
import dash_query_details_icon from 'assets/img/dashboards/dash-query-details.svg';
export default Vue.extend({
    components: { WidgetFrame, QueryRow },
    props: {
        query: { type: Object, required: false, default: null },
        savedQueries: { type: Array, required: true, default: null },
        devMode: { type: Boolean, required: false, default: false },
        /** widget banner to display */
        banner: { type: Object, default: () => null, required: false },
        projectId: { type: Number, required: false, default: null },
        analysisId: { type: Number, required: false, default: null },
        dateFieldIndex: { type: Object, default: () => ({}) },
        conceptColours: { type: Object, required: true },
        userIsViewer: { type: Boolean, required: false, default: false },
        /** Add a skeleton mask (used when reloading state between dashboards) */
        masked: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            dash_query_details_icon
        };
    },
    computed: {
        displayQuery() {
            return this.query
                ? QueryUtils.botanicToQueryRows(this.query.query_value)
                : [];
        },
        encodedQuery() {
            return Utils.generateEncodedQuery(this.displayQuery);
        },
        goToQuery() {
            return {
                params: { projectId: `${this.projectId}`, analysisId: `${this.analysisId}` },
                query: { q: this.encodedQuery, savedQuery: this.query.id },
                name: 'browse-excerpts',
            };
        },
    },
});
